import { c as _c } from "react/compiler-runtime";
import { AspectRatio, Avatar, HStack, Heading, Stack, Text, VStack, Separator } from '@chakra-ui/react';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import ReactPlayer from 'react-player';
interface SocialVideoCardProps {
  personFullName?: string;
  personFirstName?: string;
  personLastName?: string;
  personTitle?: string;
  personAvatarUrl?: string;
  companyName?: string;
  videoTitle?: string;
  videoUrl?: string;
  bgColor?: string;
  bgGradient?: string;
  color?: string;
}
const SocialVideoCard: React.FC<SocialVideoCardProps> = t0 => {
  const $ = _c(36);
  const {
    personFullName,
    personFirstName,
    personLastName,
    personTitle,
    personAvatarUrl,
    companyName,
    videoTitle,
    videoUrl,
    bgColor,
    bgGradient
  } = t0;
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t1;
  if ($[0] !== getBreakpointValue) {
    t1 = getBreakpointValue(["column", "column"]);
    $[0] = getBreakpointValue;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      vimeo: {
        playerOptions: {
          badge: 0,
          autopause: 0,
          player_id: 0,
          app_id: 58479
        }
      }
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== videoUrl) {
    t3 = <AspectRatio borderRadius="xl" boxShadow="sm" overflow="hidden" ratio={1.7777777777777777} width="full"><ReactPlayer controls={true} height="100%" light={false} pip={true} playing={false} url={videoUrl} width="100%" config={t2} /></AspectRatio>;
    $[3] = videoUrl;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== videoTitle) {
    t4 = <Heading size="md">{videoTitle}</Heading>;
    $[5] = videoTitle;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Separator border="2px solid" borderColor="whiteAlpha.300" />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Text>{" An interview with"}</Text>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== getBreakpointValue) {
    t7 = getBreakpointValue(["sm", "sm"]);
    $[9] = getBreakpointValue;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Avatar.Fallback />;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== personAvatarUrl) {
    t9 = <Avatar.Image src={personAvatarUrl} />;
    $[12] = personAvatarUrl;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t7 || $[15] !== t9) {
    t10 = <Avatar.Root boxShadow="base" size={t7}>{t8}{t9}</Avatar.Root>;
    $[14] = t7;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  const t11 = personFullName ? personFullName : `${personFirstName} ${personLastName}`;
  let t12;
  if ($[17] !== t11) {
    t12 = <Text textStyle="labelMd">{t11}</Text>;
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  const t13 = personTitle && companyName ? `${personTitle}, ${companyName}` : personTitle || companyName;
  let t14;
  if ($[19] !== t13) {
    t14 = <Text opacity={0.5} textStyle="badgeSm">{t13}</Text>;
    $[19] = t13;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== t12 || $[22] !== t14) {
    t15 = <VStack align="flex-start" gap={0}>{t12}{t14}</VStack>;
    $[21] = t12;
    $[22] = t14;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== t10 || $[25] !== t15) {
    t16 = <VStack align="flex-start" width="full">{t6}<HStack align="center" gap={4} width="full">{t10}{t15}</HStack></VStack>;
    $[24] = t10;
    $[25] = t15;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t16 || $[28] !== t4) {
    t17 = <VStack gap={4}>{t4}{t5}{t16}</VStack>;
    $[27] = t16;
    $[28] = t4;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== bgColor || $[31] !== bgGradient || $[32] !== t1 || $[33] !== t17 || $[34] !== t3) {
    t18 = <Stack bg={bgGradient} bgColor={bgColor} borderRadius="xl" boxShadow="sm" direction={t1} gap={4} justify="space-between" padding={4} position="relative" width="full">{t3}{t17}</Stack>;
    $[30] = bgColor;
    $[31] = bgGradient;
    $[32] = t1;
    $[33] = t17;
    $[34] = t3;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  return t18;
};
export default SocialVideoCard;